import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { NeonEdge as NeonEdgeAtom } from '@sorare/core/src/atoms/ui/NeonEdge';
import { borderGradientStyle } from '@sorare/core/src/style/utils';

export const SeriesCardPackGroupWrapper = styled.div`
  position: relative;
  width: 100%;
  background:
    linear-gradient(
      180deg,
      rgba(14, 14, 14, 0.5) 0%,
      rgba(14, 14, 14, 0.9) 79.85%,
      #0e0e0e 99.69%
    ),
    var(--background-image) top left / cover no-repeat;
  border-radius: var(--double-unit);
  --border-gradient: linear-gradient(
    to bottom,
    var(--league-color) 0%,
    transparent 20%
  );
  ${borderGradientStyle};
  overflow: hidden;
`;

export const Grid = styled.div`
  display: grid;
  padding-top: var(--double-unit);
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: var(--double-unit);
`;

export const MainPack = styled(Vertical)`
  grid-column: span 2;
  width: 100%;
  gap: var(--triple-unit);
`;

export const SecondaryPack = styled.div`
  grid-column: span 1;
  border: 1px solid var(--c-nd-100);
  border-radius: var(--double-unit);
  padding: var(--double-unit);
`;
export const Header = styled.div`
  grid-column: span 2;
  padding-bottom: var(--double-unit);
  border-bottom: 1px solid var(--c-nd-150);
`;

export const Logo = styled.img`
  width: 100%;
  height: calc(8 * var(--unit));
  object-fit: contain;
  object-position: center;
`;

export const NeonEdge = styled(NeonEdgeAtom)`
  width: 100%;
  padding: var(--double-unit);
`;
